import { MONTHS, WEEKDAYS } from "./constants";
import { TimeTable } from "./TimeTable";
import { DaySelector } from "./DaySelector";
import { Utils } from "./Utils";

export class ReservationSystem {
  constructor() {
    // Try to load saved date from localStorage, fallback to current date
    const savedDate = localStorage.getItem("selectedDate");
    this.selectedDate = savedDate ? new Date(savedDate) : new Date();

    // Initialize currentDate based on selectedDate instead of new Date()
    this.currentDate = new Date(this.selectedDate);

    this.timeTable = new TimeTable();
    this.daySelector = new DaySelector(this.handleDateSelect.bind(this));

    this.setupEventListeners();
    this.updateMonthDisplay();
    this.daySelector.initialize(this.currentDate, this.selectedDate);
    this.adjustTableHeight();

    // Initial load of bookings
    this.timeTable.updateDate(this.selectedDate);
	
	this.setCurDate(this.selectedDate);

    window.addEventListener("load", () => this.adjustTableHeight());
    window.addEventListener("resize", () => this.adjustTableHeight());
	
	this.setAdminImageSrc();
  }
  
  setAdminImageSrc() {
    const adminImage = document.getElementById("admin").querySelector("img");
    if (adminImage) {
      adminImage.src = "/img/admin.png";
    }
  }

  handleDateSelect(date) {
    this.selectedDate = date;
    // Save selected date to localStorage
    localStorage.setItem("selectedDate", date.toISOString());

    this.timeTable.updateDate(date);

    document.querySelectorAll(".day-button").forEach((button) => {
      button.classList.remove("selected");
    });

    const buttons = Array.from(document.querySelectorAll(".day-button"));
    const selectedIndex = date.getDate() - 1;
    if (buttons[selectedIndex]) {
      buttons[selectedIndex].classList.add("selected");
    }
	
	this.setCurDate(date);
  }
  
  setCurDate(date) {
	document.getElementById("curDay").textContent = WEEKDAYS[this.daySelector.getWeekDay(date)];
	document.getElementById("curDate").textContent = date.getDate() + '.' + (date.getMonth() + 1);
  }

  adjustTableHeight() {
    const tableContainer = document.querySelector(".overflow-x-auto");
    const windowHeight = window.innerHeight;

    // Set table container height to window height
    tableContainer.style.height = `${windowHeight}px`;
  }

  updateMonthDisplay() {
    const monthYear = document.getElementById("currentMonth");
    monthYear.textContent = `${
      MONTHS[this.currentDate.getMonth()]
    } ${this.currentDate.getFullYear()}`;
  }

  setupEventListeners() {
    document.getElementById("prevMonth").addEventListener("click", () => {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.updateMonthDisplay();
      this.daySelector.initialize(this.currentDate, this.selectedDate);
    });

    document.getElementById("nextMonth").addEventListener("click", () => {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      this.updateMonthDisplay();
      this.daySelector.initialize(this.currentDate, this.selectedDate);
    });

    document.getElementById("timeTable").addEventListener("click", (e) => {
      const cell = e.target.closest("td[data-hour]");
      if (cell) {
        const hour = cell.dataset.hour;
        const room = cell.dataset.room;
        console.log(
          `Clicked: Hour ${hour}, Room ${room}, Date: ${this.selectedDate.toLocaleDateString(
            "ru-RU"
          )}`
        );
      }
    });
	
	const shipHeaders = document.querySelectorAll('.ship-header');

	shipHeaders.forEach((shipHeader) => {
	  shipHeader.addEventListener('click', (e) => {
		const shipName = e.currentTarget.dataset.shipName;
		e.currentTarget.classList.toggle("block");
		this.sendBlockRequest(shipName, this.selectedDate);
	  });
	});
  }
  
  async sendBlockRequest(shipName, date) {
	try {
		const response = await fetch('/api/block/', {
		  method: 'POST',
		  headers: {
			'Content-Type': 'application/json',
		  },
		  body: JSON.stringify({
			shipName,
			date: date.toLocaleDateString("ru-RU"),
		  }),
		});

		if (!response.ok) {
		  throw new Error(`Ошибка HTTP: ${response.status}`);
		}

		const data = await response.json();
		console.log('Ответ от сервера:', data);
	  } catch (error) {
		console.error('Ошибка при выполнении запроса:', error);
	  }  
  }
}
